import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0de78be1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-input-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["BaseInput"], {
      ref: "baseInput",
      placeholder: $props.placeholder,
      type: $props.type,
      name: $props.name,
      label: $props.label,
      maxlength: $props.maxlength,
      errorMessage: $props.errorMessage,
      inputmode: $props.inputmode,
      enableClearText: $props.enableClearText,
      required: $props.required,
      disabled: $props.disabled,
      readonly: $props.readonly,
      value: $setup.inputValue,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.inputValue) = $event)),
      onOnInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onInput'))),
      onOnFocused: $setup.onFocused,
      onOnBlurred: $setup.onBlurred,
      rules: $props.rules
    }, null, 8 /* PROPS */, ["placeholder", "type", "name", "label", "maxlength", "errorMessage", "inputmode", "enableClearText", "required", "disabled", "readonly", "value", "rules"])
  ]))
}